import { useContext, useMemo } from 'react'
import {
  GlobalContext,
  TenantSettingsContext,
  UserContext,
} from '../App'
import { REGISTRY } from './registry'
import { buildNavContext, getEntryAccess } from './visibility'

// The registry evaluated for the signed-in user. Unlike the old search ctx,
// this one includes orgSettings, so check() rules that depend on org
// configuration (meds administration disabled, speak-up off, imaging
// approvers) evaluate correctly everywhere.
export const useNavContext = () => {
  const { user } = useContext(UserContext)
  const { tenantInfo } = useContext(GlobalContext)
  const { orgSettings } = useContext(TenantSettingsContext).orgConfig ?? {}

  return useMemo(
    () => buildNavContext({ user, tenantInfo, orgSettings }),
    [user, tenantInfo, orgSettings],
  )
}

// Every registry entry the user can actually open (tier locks excluded),
// in registry order.
export const useVisiblePages = () => {
  const ctx = useNavContext()
  return useMemo(
    () => ({
      ctx,
      pages: REGISTRY.filter((entry) => getEntryAccess(entry, ctx) === 'visible'),
    }),
    [ctx],
  )
}
